/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

import { Component, Vue } from 'vue-property-decorator';
import {Action, Getter} from 'vuex-class';
import pkce from '@/services/pkce';

const namespace: string = 'userSessionModule';

/**
 * Site navigation component.
 *
 * @author Jonny Cook <jcook@frontier.co.uk>
 */
@Component({
    name: 'c-site-navigation',
})
export default class SiteNavigation extends Vue {
    @Getter('authenticated', {namespace}) public authenticated!: boolean;

    // Page Title
    @Action('updatePageTitle', {namespace: 'settingsModule'})
    public updatePageTitle!: (title: string) => void;

    // Update current view name in state
    @Action('updateCurrentView', {namespace: 'userSessionModule'})
    public updateCurrentView!: (view: {name: string, params?: any} | undefined) => void;

    /**
     * Login action event
     */
    public loginUser(): void {
        window.location.href = pkce.getAuthUrl();
    }

    /**
     * Logout user action event.
     */
    public logoutUser(): void {
        this.$router.push({name: 'logout'});
    }

    /**
     * Goto Search.
     */
    public goToSearch(anchor: string): void {

        if ('home' !== this.$router.currentRoute.name) {
            this.$router.push({name: 'home', hash: 'search'});
        }

        // Scroll to anchor
        const element: HTMLElement | null = document.getElementById(anchor);
        if (null !== element) {
            element.scrollIntoView({
                behavior: 'smooth',
            });
        }
    }

    /**
     * Goto Page.
     */
    public goToPage(pageName: string): void {
        // have same code in siteFooter
        if ('report-issue' === pageName) {
            this.updateCurrentView({name: pageName});
            this.updatePageTitle(this.$i18n.translate('menu.header.reportIssue', {}) || '');
        }

        this.$router.push({name: pageName});
    }
}
